<template>
  <div>
    <b-row>
      <b-col>
        <section-breakdown
          name="Verbal"
          id="Verbal"
          display-name="Reading and Writing"
          :section="scoreReport.Verbal"
          :color="scoreReport.color"
        />
        <section-breakdown
          name="Math"
          id="Math"
          display-name="Math"
          :section="scoreReport.Math"
          :color="scoreReport.color"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SectionBreakdown from "./SectionBreakdown";
export default {
  name: "SatScores",
  components: { SectionBreakdown },
  props: {
    scoreReport: {
      type: Object,
      default: null
    }
  },
  computed: {}
};
</script>

<style scoped></style>
